// lib/rozliczenia/miesiac.ts — pomocniki widoku ROZLICZEŃ MIESIĘCZNYCH (bez Reacta, bez sieci).
// Przypisanie tygodni do miesiąca liczy SERWER (`server/lib/rozliczenia/miesiac.js`); tu tylko
// nazwy, nawigacja po miesiącach i postać kwoty do wklejenia w program do faktur.

export const MIESIACE = [
  'styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec',
  'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień',
] as const;

export interface MiesiacRozliczen { rok: number; miesiac: number }

/** „WRZESIEŃ 2026”. */
export function etykietaMiesiaca(m: MiesiacRozliczen): string {
  return `${MIESIACE[m.miesiac - 1]!.toUpperCase()} ${m.rok}`;
}

/** Miesiąc przesunięty o `o` (−1 = poprzedni, +1 = następny), z przejściem przez rok. */
export function przesunMiesiac(m: MiesiacRozliczen, o: number): MiesiacRozliczen {
  const indeks = m.rok * 12 + (m.miesiac - 1) + o;
  return { rok: Math.floor(indeks / 12), miesiac: (indeks % 12) + 1 };
}

/** Kwota do wklejenia w program do faktur: „934,80” — bez spacji tysięcy i bez „zł”. */
export function kwotaDoSchowka(grosze: number): string {
  const znak = grosze < 0 ? '-' : '';
  const modul = Math.abs(grosze);
  return `${znak}${Math.floor(modul / 100)},${String(modul % 100).padStart(2, '0')}`;
}
